import styled from 'styled-components';
import { Container } from 'react-bootstrap';

/*********** this is Styles for NavBar Component *********/

export const MyNav = styled.nav`
    background-color: var(--primaryColor);
    padding: 20px 0px;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 22;
    width: 100%;
    transition: all .3s ease;
    /* position: relative; */
`;

export const NavContainer = styled(Container)`
    display: flex;
    justify-content: space-between;
`;

export const Brand = styled.div`
    h2{
        font-size: 20px;
        font-weight: 700;
        color: white;
        text-transform: uppercase;
        /* line-height: 35px; */
        padding: 0px 12px;
    }
`;

export const NavLinks = styled.div`
    display: flex;
    justify-content: space-around;
    flex:1;

    @media (max-width:1000px){
         display:NONE;
    } 
 `;

export const Links = styled.div`
 display: flex;
    >a{
        padding: 3px 17px;
        text-decoration: none;
        color: white;
        font-size: 14px;
        font-weight: 600;
        line-height: 35px;
        border-radius: 10px;
        margin-right: 5px;
        :hover{
            background-color: var(--darkColor);
        }
    }
.active{
    background-color: var(--darkColor);
}
 `;

export const NavBtns = styled.div`
>a{
    background-color: #2a96d1;
     margin-right: 11px;
    text-align: center;
    line-height: 40px;
    border-radius: 2px;
    color: white;
    font-weight: 600;
    font-size: 14px;
    display: inline-block;
    padding: 0 20px;
    height: 40px;
}
>a:nth-child(1){
    background-color: transparent;
    color: white;
    border:none;
    :hover{
        background-color: #2a96d1;
    }
}

/* @media (max-width:1000px){
    padding: 13px;
} */
 `;

export const DropDown = styled.div`
position: relative;
> a{
    padding: 3px 22px;
     text-decoration: none;
    color: white;
    font-size: 14px;
    font-weight: 600;
    line-height: 35px;
    height: 100%;
    display: inline-block;
    border-radius: 10px;
    i{
        font-size: 17px;
        margin-left: 4px;
        color: white;
    }
}
:hover div{
    transform: scale(1);
 }


`;
export const DropDownContant = styled.div`
position: absolute;
top: 50px;
background-color: var(--darkColor);
z-index: 1;
width: 156px;
padding: 1px 0px;
box-shadow: 0 1px 5px rgb(0 0 0 / 10%);
border-radius: 5px;
transform: scale(0);
 >a{
    padding: 14px 5px;
    border-bottom: 1px solid rgb(31 33 37 / 70%);
    display: block;
    color: white;
    font-size: 11px;
    :hover{
        padding-left: 25px;
    }
}
`;


export const NavToggles = styled.div`
    flex-direction: column;
    cursor: pointer;
    display: none;
    span{
    width: 35px;
    height: 3px;
    margin-bottom: 4px;
    background-color: white;
    display: block;
    transition: all .3s;
}

span:nth-child(2){
      display: ${props => props.active ? 'none' : "block"};
    }
span:nth-child(1){

    transform: ${props => props.active ? 'rotate(44deg) translate(6px,3px)' : "rotate(0deg) translate(0px,0px)" };
}   
span:nth-child(3){

    transform: ${props => props.active ? 'rotate(-49deg)' : "rotate(0deg)" };
} 

@media (max-width:1000px){
    display: flex;
    justify-content: center;
    align-items: center   
}
`;

/*********** this is Styles for NavBar Component *********/
